module.exports = __webpack_public_path__ + "img/banner.b303d7a5.png";